import { createSlice } from "@reduxjs/toolkit";
import { orderProductRemove } from "./orderAsyncThunk";

const orderProductRemoveSlice = createSlice({
  name: "order",
  initialState: {
    isLoading: false,
    isSuccess: false,
    payload: "",
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [orderProductRemove.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [orderProductRemove.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.isFail = false;
      state.payload = action.payload.message;
    },
    [orderProductRemove.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isFail = true;
    },
  },
});

export default orderProductRemoveSlice.reducer;
